/* eslint-disable @nx/enforce-module-boundaries */
import {
  AppointmentsIcon,
  CalendarIcon,
  CalendarNewIcon,
  MyCalendarSideBar,
  EventIcon,
  RecordingIcon,
  MyEventsIcon,
  UpcomingMeetingsIcon,
  EventIconColored,
  JoinMeetingColoredIcon,
  JoinMeetingIcon,
  RecordVideoCameraIcon,
  ScheduleIcon,
  AppointmentScheduleIcon,
} from '@mybridge/icons';
import {
  Box,
  Button,
  Card,
  Divider,
  Heading,
  VStack,
  Stack,
  Circle,
  SimpleGrid,
} from '@mybridge/ui';
import Link from 'next/link';
import { useDispatch, useSelector } from 'react-redux';
import {
  generateMeetingId,
  setJoinMeetNow,
  setMeetNow,
} from 'v4/store/actions/meeting.actions';
import { getUpcomingMeetingCount } from 'v4/store/actions/global.data.actions';
import { isMobile } from 'react-device-detect';
import { useRouter } from 'next/router';
import { Badge, Input, InputGroup, InputLeftElement, InputRightElement, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text } from '@chakra-ui/react';
import { useEffect, useMemo, useState } from 'react';
import { CopyIcon } from '@chakra-ui/icons';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';
import { ANALYTICS_EVENTS, trackEvent } from 'v4/utils/analyticsEvents';
import { useNumberFormatter } from '@mybridge/ui/custom-hooks/useNumberFormatter'; // Added import
import { useBranchLink } from 'v4/components/branch-sdk/branch-create';

const CalendarSidebar = ({ isDashboard, ...props }) => {
  const dispatch = useDispatch();
  const { pathname, push } = useRouter();
  const { t } = useTranslator();
  const { unreadMeetingCount } = useSelector((state) => state.globalData);
  const [meetNowModal, setMeetNowModal] = useState(false);
  const {generatedMeetingId} = useSelector((state) => state?.meeting);
  const [domain, setDomain] = useState('');
  const [copyText, setCopyText] = useState(<CopyIcon height={"18px"} width={"18px"}/>)
  const direction = useDirection();
  const { userProfileInfo } = useSelector((state) => state.userProfile);
  const { isReady, createBranchLink } = useBranchLink();
  const userSlug = userProfileInfo?.slug || 'anonymous';
  const { formatNumber } = useNumberFormatter(); // Added hook usage

  const mainTabs = useMemo(() => {
    return [
      {
        title: t('common.newMeeting') || "New Meeting",
        icon: <EventIconColored width="20" height="20" />,
        onClick: (e) => dispatch(generateMeetingId()).then((res) => {
          if (res) setMeetNowModal(true);
        })
      },
      {
        title: t('common.joinMeeting') || "Join a Meeting",
        icon: <JoinMeetingColoredIcon />,
        onClick: (e) => dispatch(setJoinMeetNow(true))
      },
      {
        title: t('common.scheduleMeeting') || "Schedule a Meeting",
        icon: <CalendarNewIcon width="20" height="20" />,
        onClick: (e) => push('/profile/calendar/schedule'),
      },
      {
        title: t('common.appointmentSchedule') || "Appointment Schedule",
        icon: <AppointmentScheduleIcon width="27" height="27" />,
        onClick: (e) => push('/profile/calendar/appointments'),
      },
    ];
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setDomain(window.location.origin+`/meet/${generatedMeetingId}`);
    }
  }, [domain, generatedMeetingId]);

  useEffect(() => {
    if (pathname === '/profile/calendar' || pathname === '/profile/calendar/calendar-listing') {
      dispatch(getUpcomingMeetingCount());
    }
  }, [pathname, dispatch]);

  const handleGenerateLink = async () => {
    try {
      const url = await createBranchLink({
        itemType: 'meeting',
        itemId: generatedMeetingId,
      });
      if (url) {
        copyToClipboard(url);
      }
    } catch (err) {
      console.error(err);
    }
  };
  
  const copyToClipboard = (url) => {
    navigator.clipboard.writeText(url||domain).then(() => {
      setCopyText(t('myCalendar.copied') || 'Copied');
      setTimeout(() => setCopyText(<CopyIcon height={"18px"} width={"18px"}/>), 5000);
    });
  };
  return (
    <>
      {isMobile ? (
        <SimpleGrid columns={2} spacing={3}>
          {mainTabs.map?.((mi, mind) => (
            <Box
              key={mi.title}
              onClick={(e) => {
                mi.onClick(e)
              }}
            >
              <VStack
                alignItems="flex-start"
                gap={0}
                borderRadius="8px"
                border="1px solid #ddd"
                boxShadow= '0px 2px 4px 0px #00000029'
                fontSize='12px'
                flexDirection={"column"}
                minH={"88px"}
                justifyContent={'center'}
                p={3}
              >
                {mi.icon}
                <Text fontSize={["sm"]}>{mi.title}</Text>
              </VStack>
            </Box>
          ))}
        </SimpleGrid>
      ) : (
        <>
        <Stack>
          {!isDashboard && (
            <VStack align="stretch" p={2}>
              {/* <Heading as="h4" color="#3B718D" fontSize="18px" mb={4}>
                Calendar
              </Heading> */}
              <Link href="/profile/calendar/">
                <Button
                borderRadius="50px"
                  variant="ghost"
                  justifyContent="flex-start"
                  fontWeight="400"
                  color="#575757"
                  // mb={4}
                  w="100%"
                  isActive={pathname === '/profile/calendar' ? true : false}
                  _active={{
                    backgroundColor: '#EDEDED',
                    cursor: 'pointer',
                    // color: 'brandPrimary.500',
                    fontWeight: '400',
                    boxShadow: '0px 14px 44px 0px rgba(0, 0, 0, 0.04)',
                    // path: {
                    //   fill: 'brandPrimary.500',
                    // },
                  }}
                  sx={{
                    ':hover': {
                      backgroundColor: '#EDEDED',
                      cursor: 'pointer',
                      // color: 'brandPrimary.500',
                      fontWeight: '400',
                      boxShadow: '0px 14px 44px 0px rgba(0, 0, 0, 0.04)',
                      // path: {
                      //   fill: 'brandPrimary.500',
                      // },
                    },
                  }}
                >
                  {t('myCalendar.myCalendar') || 'myCalendar'}
                </Button>
              </Link>

              <Link href="/profile/calendar/calendar-listing">
                <Button
                  // onClick={(e) => dispatch(setJoinMeetNow(true))}
                  borderRadius="50px"
                  variant="ghost"
                  justifyContent="flex-start"
                  fontWeight="400"
                  color="#575757"
                  // mb={4}
                  w="100%"
                  isActive={
                    pathname === '/profile/calendar/calendar-listing'
                      ? true
                      : false
                  }
                  _active={{
                    backgroundColor: '#EDEDED',
                    cursor: 'pointer',
                    // color: 'brandPrimary.500',
                    fontWeight: '400',
                    boxShadow: '0px 14px 44px 0px rgba(0, 0, 0, 0.04)',
                    // path: {
                    //   fill: 'brandPrimary.500',
                    // },
                  }}
                  sx={{
                    ':hover': {
                      backgroundColor: '#EDEDED',
                      cursor: 'pointer',
                      // color: 'brandPrimary.500',
                      fontWeight: '400',
                      boxShadow: '0px 14px 44px 0px rgba(0, 0, 0, 0.04)',
                      // path: {
                      //   fill: 'brandPrimary.500',
                      // },
                    },
                  }}
                >
                  {t('myCalendar.upcomingMeeting') || 'Upcoming meeting'}
                  {unreadMeetingCount > 0 && (
                    // <Circle
                    //   bg="brandRed.500"
                    //   color="white"
                    //   w="20px"
                    //   h="20px"
                    //   p="8px"
                    //   borderRadius="100%"
                    //   ml="8px"
                    // >
                    //   {unreadMeetingCount}
                    // </Circle>
                    <Badge
                      fontSize="12px"
                      bg="brandRed.500"
                      color="white"
                      borderRadius="100%"
                      w="25px"
                      h="25px"
                      border= '2px solid #ffffff'
                      p="3px 5px"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      ml="8px"
                      pt={"4px"}
                    >
                      {formatNumber(unreadMeetingCount)}
                    </Badge>
                  )}
                </Button>
              </Link>

              <Link href="/profile/calendar/appointments">
                <Button
                  // onClick={(e) => dispatch(setJoinMeetNow(true))}
                  borderRadius="50px"
                  variant="ghost"
                  justifyContent="flex-start"
                  fontWeight="400"
                  color="#575757"
                  // mb={4}
                  w="100%"
                  isActive={
                    pathname === '/profile/calendar/appointments' ? true : false
                  }
                  _active={{
                    backgroundColor: '#EDEDED',
                    cursor: 'pointer',
                    // color: 'brandPrimary.500',
                    fontWeight: '400',
                    boxShadow: '0px 14px 44px 0px rgba(0, 0, 0, 0.04)',
                    // path: {
                    //   fill: 'brandPrimary.500',
                    // },
                  }}
                  sx={{
                    ':hover': {
                      backgroundColor: '#EDEDED',
                      cursor: 'pointer',
                      // color: 'brandPrimary.500',
                      fontWeight: '400',
                      boxShadow: '0px 14px 44px 0px rgba(0, 0, 0, 0.04)',
                      // path: {
                      //   fill: 'brandPrimary.500',
                      // },
                    },
                  }}
                >
                  {t('myCalendar.appointments') || 'Appointments'}
                </Button>
              </Link>
              <Link href="/myevents">
                <Button
                borderRadius="50px"
                  variant="ghost"
                  justifyContent="flex-start"
                  fontWeight="400"
                  color="#575757"
                  w="100%"
                  isActive={pathname === '/myevents' ? true : false}
                  _active={{
                    backgroundColor: '#EDEDED',
                    cursor: 'pointer',
                    // color: 'brandPrimary.500',
                    fontWeight: '400',
                    boxShadow: '0px 14px 44px 0px rgba(0, 0, 0, 0.04)',
                    // path: {
                    //   fill: 'brandPrimary.500',
                    // },
                  }}
                  sx={{
                    ':hover': {
                      backgroundColor: '#EDEDED',
                      cursor: 'pointer',
                      // color: 'brandPrimary.500',
                      fontWeight: '400',
                      boxShadow: '0px 14px 44px 0px rgba(0, 0, 0, 0.04)',
                      // path: {
                      //   fill: 'brandPrimary.500',
                      // },
                    },
                  }}
                >
                  {t('myCalendar.myEvent') || 'myEvent'}
                </Button>
              </Link>
              <Link href="/profile/calendar/recordings">
                <Button
                borderRadius="50px"
                  variant="ghost"
                  justifyContent="flex-start"
                  fontWeight="400"
                  color="#575757"
                  mb={4}
                  w="100%"
                  isActive={
                    pathname === '/profile/calendar/recordings' ? true : false
                  }
                  _active={{
                    backgroundColor: '#EDEDED',
                    cursor: 'pointer',
                    // color: 'brandPrimary.500',
                    fontWeight: '400',
                    boxShadow: '0px 14px 44px 0px rgba(0, 0, 0, 0.04)',
                    // path: {
                    //   fill: 'brandPrimary.500',
                    // },
                  }}
                  sx={{
                    ':hover': {
                      backgroundColor: '#EDEDED',
                      cursor: 'pointer',
                      // color: 'brandPrimary.500',
                      fontWeight: '400',
                      boxShadow: '0px 14px 44px 0px rgba(0, 0, 0, 0.04)',
                      // path: {
                      //   fill: 'brandPrimary.500',
                      // },
                    },
                  }}
                >
                  {t('myCalendar.recordings') || 'Recordings'}
                </Button>
              </Link>
              
            </VStack>
          )}
          {!isDashboard && <Divider />}
          <VStack align="stretch" p={2}>
            <Button
              // onClick={(e) => dispatch(setMeetNow(true))}
              onClick={() => {
                dispatch(generateMeetingId()).then((res) => {
                  if (res) setMeetNowModal(true);
                  // dispatch(setMeetNow(false));
                });
              }}
              borderRadius="full"
              variant="ghost"
              height="50px"
              paddingInlineStart={isDashboard ? '10px' : '20px'}
              leftIcon={
                isDashboard ? (
                  <Box
                    borderRadius="full"
                    bg="#D9D9D9"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    w="35px"
                    h="35px"
                  >
                    <EventIconColored width="20" height="20" />
                  </Box>
                ) : (
                  <EventIconColored width="20" height="20" />
                )
              }
              justifyContent="flex-start"
              fontWeight="400"
              color="#3D5A80"
              sx={{
                ':hover': {
                  backgroundColor: 'brandGray.500',
                  cursor: 'pointer',
                  // color: 'brandPrimary.500',
                  bg: '#C6C6C6',
                  boxShadow: '0px 14px 44px 0px rgba(0, 0, 0, 0.04)',
                  // paddingInlineStart: '10px',
                  fontWeight: '400',
                  path: {
                    // fill: 'brandPrimary.500',
                  },
                },
              }}
            >
              {t('common.newMeeting') || "New Meeting"}  
              {/* meet now menu */}
            </Button>
            <Button
              onClick={(e) => dispatch(setJoinMeetNow(true))}
              variant="ghost"
              borderRadius="full"
              height="50px"
              paddingInlineStart={isDashboard ? '10px' : '20px'}
              leftIcon={
                isDashboard ? (
                  <Box
                    borderRadius="full"
                    bg="#D9D9D9"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    w="35px"
                    h="35px"
                  >
                    <JoinMeetingColoredIcon width="20" height="20" />
                  </Box>
                ) : (
                  <JoinMeetingColoredIcon width="20" height="20" />
                )
              }
              justifyContent="flex-start"
              fontWeight="400"
              color="#3D5A80"
              sx={{
                ':hover': {
                  backgroundColor: 'brandGray.500',
                  cursor: 'pointer',
                  // color: 'brandPrimary.500',
                  fontWeight: '400',
                  bg: '#C6C6C6',
                  boxShadow: '0px 14px 44px 0px rgba(0, 0, 0, 0.04)',
                  // paddingInlineStart: '10px',
                  path: {
                    // fill: 'brandPrimary.500',
                  },
                },
              }}
            >
              {t('common.joinMeeting') || "Join a Meeting"}
            </Button>
            <Link href="/profile/calendar/schedule">
              <Button
                borderRadius="full"
                variant="ghost"
                height="50px"
                paddingInlineStart={isDashboard ? '10px' : '20px'}
                leftIcon={
                  isDashboard ? (
                    <Box
                      borderRadius="full"
                      bg="#D9D9D9"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      w="35px"
                      h="35px"
                    >
                      <CalendarNewIcon width="20" height="20" />
                    </Box>
                  ) : (
                    <CalendarNewIcon width="20" height="20" />
                  )
                }
                justifyContent="flex-start"
                fontWeight="400"
                color="#3D5A80"
                w="100%"
                isActive={
                  pathname === '/profile/calendar/[slug]' ? true : false
                }
                _active={{
                  backgroundColor: '#C6C6C6',
                  cursor: 'pointer',
                  color: '#3D5A80',
                  fontWeight: '400',
                  boxShadow: '0px 14px 44px 0px rgba(0, 0, 0, 0.04)',
                  // path: {
                  //   fill: 'brandPrimary.500',
                  // },
                }}
                sx={{
                  ':hover': {
                    cursor: 'pointer',
                    fontWeight: '400',
                    backgroundColor: '#C6C6C6',
                    boxShadow: '0px 14px 44px 0px rgba(0, 0, 0, 0.04)',
                    // paddingInlineStart: '10px',
                    path: {
                      // fill: 'brandPrimary.500',
                    },
                  },
                }}
              >
                {t('common.scheduleMeeting') || "Schedule a Meeting"}
              </Button>
            </Link>
            <Link href="/profile/calendar/appointments">
              <Button
                // onClick={(e) => dispatch(setJoinMeetNow(true))}
                variant="ghost"
                borderRadius="full"
                height="50px"
                paddingInlineStart={isDashboard ? '10px' : '20px'}
                leftIcon={
                  isDashboard ? (
                    <Box
                      borderRadius="full"
                      bg="#D9D9D9"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      w="35px"
                      h="35px"
                    >
                      <AppointmentScheduleIcon />
                    </Box>
                  ) : (
                    <AppointmentScheduleIcon />
                  )
                }
                justifyContent="flex-start"
                fontWeight="400"
                color="#3D5A80"
                mb={4}
                w="100%"
                isActive={
                  pathname === '/profile/calendar/appointments' ? true : false
                }
                sx={{
                  ':hover': {
                    backgroundColor: '#C6C6C6',
                    cursor: 'pointer',
                    // color: 'brandPrimary.500',
                    fontWeight: '400',
                    bg: '#C6C6C6',
                    boxShadow: '0px 14px 44px 0px rgba(0, 0, 0, 0.04)',
                    // paddingInlineStart: '10px',
                    // path: {
                    //   fill: 'brandPrimary.500',
                    // },
                  },
                }}
              >
                {t('common.appointmentSchedule') || "Appointment Schedule"}
              </Button>
            </Link>
          </VStack>
          </Stack>
        </>
      )}
      <Modal isOpen={meetNowModal} size={'xl'} isCentered onClose={() => setMeetNowModal(false)}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader fontWeight={"400"}>{t('myCalendar.yourNewMeetingLink') || 'Your New Meeting Link'}</ModalHeader>
          <ModalCloseButton {...(direction === 'rtl') ? {left: '0.75rem', right: 'auto'} : {left: 'auto', right: '0.75rem'}} />
          <ModalBody pb={6} display={'flex'} flexDirection={'column'} gap={"20px"}>
            <Text>{t('myCalendar.meetingLinkInfo') || 'Here is the link for your new meeting!'}</Text>
            <Text fontSize={"14px"}>{t('myCalendar.copyShareInfo') || 'Copy and share it with the people you\'re meeting with and be sure to save the link so you can access it again later.'}</Text>
            <Box display="flex" alignItems="center" gap="8px">
              {isMobile ? (
                <InputGroup borderRadius={"20px"} bg='ButtonFace' overflow={'hidden'}>
                  <Input value={domain} width={"18.5rem"} isReadOnly />
                  {direction === 'rtl' ? <InputLeftElement width="4.5rem">
                    <Button variant="none" h="1.75rem" size="sm" onClick={handleGenerateLink} title={t('myCalendar.copyToClipboard') || "Copy to clipboard"}>
                      {copyText}
                    </Button>
                  </InputLeftElement> : <InputRightElement width="max-content">
                    <Button variant="none" h="1.75rem" size="sm" onClick={handleGenerateLink} title={t('myCalendar.copyToClipboard') || "Copy to clipboard"}>
                      {copyText}
                    </Button>
                  </InputRightElement>}
                </InputGroup>
              ) : (
              <InputGroup>
                <Input borderRadius={"20px"} value={domain} isReadOnly />
                {direction === 'rtl' ? <InputLeftElement width="4.5rem">
                  <Button variant="none" h="1.75rem" size="sm" onClick={handleGenerateLink} title={t('myCalendar.copyToClipboard') || "Copy to clipboard"}>
                    {copyText}
                  </Button>
                </InputLeftElement> : <InputRightElement width="max-content">
                  <Button variant="none" h="1.75rem" size="sm" onClick={handleGenerateLink} title={t('myCalendar.copyToClipboard') || "Copy to clipboard"}>
                    {copyText}
                  </Button>
                </InputRightElement>}
              </InputGroup>
              )}
            </Box>
          </ModalBody>
          <ModalFooter sx={{display: "flex", justifyContent: "start"}}>
            <Button 
              variant="primary" 
              borderRadius="30px" 
              onClick={(e) => {
                 try {
      trackEvent(ANALYTICS_EVENTS.Meeting, userSlug, {
        action: 'join_now',
        timestamp: new Date().toISOString(),
      });

    } catch (err) {
      console.error('Failed to track Meeting event:', err);
    }
                dispatch(setMeetNow(true));
                setMeetNowModal(false);
              }}
            >
              {t('myCalendar.joinNow') || 'Join Now'}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default CalendarSidebar;
